export default {
    languageSwitchLabel:"Change language",
    examStructureLabel:"Exam Structure",
    pricingLabel:"Pricing",
    examLabel:"Exam",
    aboutLabel:"About",
    contactLabel:"Contact",
}